import type {
  OrganizationMembershipWithOrganization,
  UserWithOrganizationMembershipAndSubscriptionData,
} from "@arbeidsark/shared"
import BuyNewSubscription from "../subscriptions/paymentViews/BuyNewSubscription"
import ExistingSchoolWaitingAcceptance from "./confirmationScreens/ExistingSchoolWaitingAcceptance"
import NewSchooAwaitingConfirmation from "./confirmationScreens/NewSchooAwaitingConfirmation"

export interface UserDoesNotHaveSubscriptionProps {
  user: UserWithOrganizationMembershipAndSubscriptionData
  organizationMembership: OrganizationMembershipWithOrganization | null
}

const UserDoesNotHaveSubscription: React.FC<
  UserDoesNotHaveSubscriptionProps
> = ({ user, organizationMembership }) => {
  if (organizationMembership) {
    if (organizationMembership.status === "PENDING") {
      return <ExistingSchoolWaitingAcceptance />
    } else {
      return <NewSchooAwaitingConfirmation />
    }
  }

  return <BuyNewSubscription />
}

export default UserDoesNotHaveSubscription
